import React from 'react';
import notification from 'antd/lib/notification';
import { t } from 'utils/i18n';
import { useReferencesContext } from './references-context';
import { useDetectionCrops } from './detection-crop';
import ModelPicker from './model-picker';

export default function ModelPickerHost(): JSX.Element | null {
    const references = useReferencesContext();
    const target = references?.picker ?? null;
    const crops = useDetectionCrops(target ? [target] : []);
    if (!references || !target) return null;
    const close = (): void => references.openPicker(null);
    // the drawer stays open on failure, so the choice can be retried
    const change = async (value: string): Promise<void> => {
        try {
            await references.setModel(target, value);
            close();
        } catch (error) {
            notification.error({
                message: t('Could not change the model'),
                description: error instanceof Error ? error.message : String(error),
            });
        }
    };
    return (
        <ModelPicker
            detection={target}
            crop={crops[target.clientID] ?? null}
            backendAPI={references.backendAPI}
            busy={references.finding !== null}
            onUse={(candidate) => change(candidate.path)}
            onRemove={() => change('')}
            onSearchAgain={() => { references.find([target]); }}
            onClose={close}
        />
    );
}
